export default "__VITE_ASSET__DeVTK0r7__"